module.exports = __webpack_public_path__ + "static/media/menu-open-icon.6e0d5911.svg";